<template>
    <iframe :src="mshopUrl" style="width:100%;border:0" :height="height">

    </iframe>
</template>
<script>
    export default {
        data() {
            return {
                width: "",
                height: "",
                mshopUrl: ""
            }
        },
        created(){
        let wiHeight = document.documentElement.clientHeight || document.body.clientHeight;
        this.height  = wiHeight + 'px'  
        let mshopUrl = this.$route.query.mshopUrl
        this.mshopUrl = mshopUrl     
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/mShop.vue